import axios, { AxiosError } from 'axios'
import { SERVER_URL } from '../config'

export const apiClient = axios.create({
    baseURL: SERVER_URL,
    withCredentials: true, // Important pour inclure les cookies httpOnly
    headers: {
        'Content-Type': 'application/json',
    },
})

// Interceptor pour gérer les erreurs 401 (non authentifié)
apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            // Ne pas rediriger si on est déjà sur une page de login
            const pathname = window.location.pathname
            if (!pathname.includes('/login')) {
                // Récupérer la langue depuis l'URL actuelle
                const langMatch = pathname.match(/^\/([a-z]{2})\//)
                const currentLang = langMatch ? langMatch[1] : 'fr'

                // Redirection vers la page de login avec la langue actuelle
                window.location.href = `/${currentLang}/login`
            }
        }
        return Promise.reject(error)
    },
)

// Interceptor pour les erreurs réseau
apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (!error.response) {
            // Erreur réseau
            console.error('Network error:', error.message)
        }
        return Promise.reject(error)
    },
)

export default apiClient
